import styled from "@emotion/styled";
import { Box, Stack } from "@mui/material";
import { Text } from "components/atoms/text";
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import { FunctionComponent } from "react";
import { Doughnut } from "react-chartjs-2";
import { STATUS_COLORS } from "./colors";

ChartJS.register(ArcElement, Tooltip, Legend);

const ChartWrapper = styled.div`
  height: 200px;
  position: relative;
`;

const DoughnutInner = styled.div`
  width: 100%;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  text-align: center;
  pointer-events: none;
`;

export type StatusSlice = {
  key: string;
  label: string;
  value: number;
};

interface Props {
  slices: StatusSlice[];
  centerValue: string;
  centerLabel: string;
}

const StatusDoughnut: FunctionComponent<Props> = ({
  slices,
  centerValue,
  centerLabel,
}) => {
  const data = {
    labels: slices.map((s) => s.label),
    datasets: [
      {
        data: slices.map((s) => s.value),
        backgroundColor: slices.map((s) => STATUS_COLORS[s.key] ?? "#bdbdbd"),
      },
    ],
  };
  const options = {
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    elements: { arc: { borderWidth: 3 } },
    cutout: "75%",
  };

  return (
    <>
      <ChartWrapper>
        <DoughnutInner>
          <Text fontWeight={"700"} fontSize={"27px"}>
            {centerValue}
          </Text>
          <Text secondary fontWeight={"600"} fontSize={"12px"}>
            {centerLabel}
          </Text>
        </DoughnutInner>
        <Doughnut data={data} options={options} />
      </ChartWrapper>
      <Stack mt={3} spacing={1}>
        {slices.map((s) => (
          <Stack
            key={s.key}
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: STATUS_COLORS[s.key] ?? "#bdbdbd",
                }}
              />
              <Text fontSize={"13px"}>{s.label}</Text>
            </Stack>
            <Text fontSize={"13px"} fontWeight={"700"}>
              {s.value}
            </Text>
          </Stack>
        ))}
      </Stack>
    </>
  );
};

export default StatusDoughnut;
